import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ConsentConfirmPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | already | error

  useEffect(() => {
    const confirmConsent = async () => {
      try {
        const res = await axios.post(`${API_URL}/api/consent/confirm/${token}`);
        if (res.data.status === 'already_confirmed') {
          setStatus('already');
        } else {
          setStatus('success');
        }
      } catch (err) {
        setStatus('error');
      }
    };
    confirmConsent();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        {status === 'loading' && (
          <>
            <Loader2 size={48} className="mx-auto text-blue-700 animate-spin mb-4" />
            <h1 className="text-xl font-semibold mb-2">Confirmation en cours…</h1>
            <p className="text-gray-600">Nous validons votre consentement.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={64} className="mx-auto text-green-600 mb-4" />
            <h1 className="text-2xl font-bold mb-3" style={{ color: '#1e3a8a' }}>
              Consentement confirmé
            </h1>
            <p className="text-gray-700 mb-2">
              Merci. Votre dossier pourra désormais être transmis à un avocat partenaire
              spécialisé en droit du recouvrement.
            </p>
            <p className="text-sm text-gray-500 mb-6">
              Vous pouvez retirer votre consentement à tout moment en nous contactant.
            </p>
            <Button onClick={() => navigate('/')} className="w-full">
              Retour à l'accueil
            </Button>
          </>
        )}
        {status === 'already' && (
          <>
            <CheckCircle size={64} className="mx-auto text-green-600 mb-4" />
            <h1 className="text-2xl font-bold mb-3" style={{ color: '#1e3a8a' }}>
              Déjà confirmé
            </h1>
            <p className="text-gray-700 mb-6">
              Votre consentement avait déjà été validé. Aucune action supplémentaire n'est requise.
            </p>
            <Button onClick={() => navigate('/')} className="w-full">
              Retour à l'accueil
            </Button>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle size={64} className="mx-auto text-red-600 mb-4" />
            <h1 className="text-2xl font-bold mb-3 text-red-700">Lien invalide</h1>
            <p className="text-gray-700 mb-6">
              Ce lien de confirmation est invalide ou a expiré. Si vous souhaitez tout de même
              partager votre dossier avec un avocat partenaire, contactez-nous.
            </p>
            <Button onClick={() => navigate('/')} className="w-full">
              Retour à l'accueil
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default ConsentConfirmPage;
